import React from "react";
import {
  IconButton,
  Avatar,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Toolbar,
  Box,
  Typography,
  Divider,
  styled,
} from "@mui/material";
import { IWithClassName } from "../../theme/default.theme";
import { SvgIconComponent } from "@mui/icons-material";
import { useAppSelector } from "../../redux/store";

interface IMenuItem {
  name: string;
  path: string;
  Icon: SvgIconComponent;
  adminOnly?: boolean;
}
interface IProps extends IWithClassName {
  menuItems: Array<IMenuItem>;
  settingsItems: Array<IMenuItem>;
}

const SideMenu = ({ menuItems, className }: IProps) => {
  const { auth, user } = useAppSelector((state) => state);
  return (
    <Box className={`side-menu-cont ${className}`}>
      <Box className="menu-section">
        <Toolbar>
          <IconButton
            size="large"
            edge="start"
            color="inherit"
            aria-label="menu"
          >
            <img src="/assets/images/logo.png" alt="logo" height={32} />
          </IconButton>
        </Toolbar>
        <Divider />
        <List>
          {menuItems.map(
            ({ name, path, Icon, adminOnly }) =>
              ((adminOnly && auth.role === "admin") || !adminOnly) && (
                <ListItemButton LinkComponent={"a"} href={path} key={name}>
                  <ListItemIcon>
                    <Icon />
                  </ListItemIcon>
                  <ListItemText primary={name} />
                </ListItemButton>
              ),
          )}
        </List>
      </Box>

      <Box className="setting-section">
        {/* <List>
          {settingsItems.map(({ name, path, Icon }) => (
            <ListItemButton LinkComponent={"a"} href={path} key={name}>
              <ListItemIcon>
                <Icon />
              </ListItemIcon>
              <ListItemText primary={name} />
            </ListItemButton>
          ))}
        </List> */}
        <Divider />
        <Toolbar>
          <Box className="profile-name-cont">
            <IconButton>
              <Avatar alt="user" src="/assets/images/demo-user.png" />
            </IconButton>
            <Box className="profile-name">
              <Box component="span">
                <Typography component="h6">
                  {user.info.data?.name ?? ""}
                </Typography>
                <Typography className="role-cont">
                  {user.info.data?.role ?? ""}
                </Typography>
              </Box>
            </Box>
          </Box>
        </Toolbar>
      </Box>
    </Box>
  );
};

export default styled(SideMenu)(({ theme }) => ({
  ".role-cont": {
    textTransform: "capitalize",
  },
}));
